import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react';
import { colors } from './styles';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'link';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  busy?: boolean;
  children: ReactNode;
}

const variantStyles: Record<Variant, CSSProperties> = {
  primary: {
    background: `linear-gradient(135deg, ${colors.cyanDark} 0%, ${colors.cyanMid} 100%)`,
    color: colors.bg,
    border: 'none',
    fontWeight: 600,
  },
  secondary: {
    background: colors.cyanBtnBg,
    border: `1px solid ${colors.cyanBtnBorder}`,
    color: colors.cyan,
    fontWeight: 600,
  },
  ghost: {
    background: 'transparent',
    border: `1px solid ${colors.borderLight}`,
    color: colors.muted,
    fontWeight: 500,
  },
  danger: {
    background: colors.dangerBg,
    border: `1px solid ${colors.dangerBorder}`,
    color: colors.danger,
    fontWeight: 500,
  },
  link: {
    background: 'transparent',
    border: 'none',
    color: colors.cyan,
    fontWeight: 500,
    padding: '0',
    textDecoration: 'underline',
  },
};

export function Button({ variant = 'primary', busy, children, style, disabled, ...props }: ButtonProps) {
  const isDisabled = disabled || busy;
  return (
    <button
      disabled={isDisabled}
      style={{
        padding: '10px 24px',
        borderRadius: '8px',
        fontSize: '0.85rem',
        cursor: isDisabled ? 'wait' : 'pointer',
        opacity: isDisabled ? 0.55 : 1,
        transition: 'opacity 0.15s',
        ...variantStyles[variant],
        ...style,
      }}
      {...props}
    >
      {busy ? '...' : children}
    </button>
  );
}
